import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FileShareService} from '../../../_services/api/file-share.service';

export interface AvailablePeriod {
  days: number;
  label: string;
}

@Component({
  selector: 'app-create-share-files-dialog',
  templateUrl: './create-share-files-dialog.component.html',
  styleUrls: ['./create-share-files-dialog.component.scss', '../../../../inputGroup.scss']
})
export class CreateShareFilesDialogComponent implements OnInit {

  status: string;
  createShareFileForm: FormGroup;
  predefinedAvailablePeriods: AvailablePeriod[];
  selectedAvailablePeriodLabel: string;
  recipientEmails: string[];
  startDeletingByBackspace: boolean;
  badEmailInput: boolean;
  doneTime: number;

  @ViewChild('passwordInput') passwordInput: ElementRef;

  constructor(public dialogRef: MatDialogRef<CreateShareFilesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private fileShareService: FileShareService) {
    this.status = 'showForm';
    this.predefinedAvailablePeriods = [
      {days: 1, label: '24 hours'},
      {days: 3, label: '3 days'},
      {days: 7, label: '7 days'},
      {days: 14, label: '2 weeks'},
      {days: 30, label: '1 month'},
    ];
    this.recipientEmails = [];
    this.startDeletingByBackspace = true;
    this.badEmailInput = false;
  }


  ngOnInit(): void {
    this.createShareFileForm = this.formBuilder.group({
      password: [''],
      days_active: [7],
      recipient_emails: ['', [Validators.required, Validators.email]],
      subject: [''],
      message: [''],
    });
  }

  addEmail(){
    if (this.createShareFileForm.controls.recipient_emails.hasError('email')) {
      this.badEmailInput = true;
    } else {
      if (this.createShareFileForm.value.recipient_emails.length > 0) {
        this.recipientEmails.push(this.createShareFileForm.value.recipient_emails);
        this.createShareFileForm.patchValue({recipient_emails: ''});
      }
    }
  }

  emailFieldFocusOut() {
    this.addEmail();
  }

  inputTyping(event: any) {
    this.badEmailInput = false;
    if (event.key === 'Enter' || event.key === ',' || event.key === 'Tab' || event.key === ';') {
      event.preventDefault();
      this.addEmail();
    } else if (event.key === 'Backspace') {
      if (this.createShareFileForm.value.recipient_emails.length === 0){
        if (this.startDeletingByBackspace) {
          this.recipientEmails.pop();
        } else {
          this.startDeletingByBackspace = true;
        }
      }
    } else {
      this.startDeletingByBackspace = false;
    }

    if (event.key === 'Tab') {
      if (this.recipientEmails.length > 0 && this.createShareFileForm.value.recipient_emails.length === 0) {
        this.passwordInput.nativeElement.focus();
      }
    }
  }

  submit() {
    this.selectedAvailablePeriodLabel = this.predefinedAvailablePeriods.filter( x => x.days === Number(this.createShareFileForm.value.days_active))[0].label;
    this.status = 'loading';
    const formParams = this.createShareFileForm.value;
    formParams.recipient_emails = this.recipientEmails.join(',');
    this.fileShareService.create(this.data.docIds, formParams).subscribe( res => {
      this.doneTime = Number(new Date().getTime());
      this.status = 'done';
    });
  }

  deleteRecipientEmail(name: string) {
    this.recipientEmails = this.recipientEmails.filter(item => item !== name);
  }

  close() {
    this.dialogRef.close();
  }

}
